import React from "react";
import {CheckCircleIcon} from "@heroicons/react/16/solid";
import {Icon} from "peggirkit";
import {FulfillmentStatus} from "@/data/entities/restaurant";
import {twJoin} from "tailwind-merge";

type StatusClassNames = {
    [key in FulfillmentStatus]: string;
};

const buttonClassNames: StatusClassNames = {
    "DEFAULT": "border-green-200 dark:border-green-700 bg-green-200/20 dark:bg-green-700/10",
    "BUSY": "border-yellow-200 dark:border-yellow-700 bg-yellow-200/20 dark:bg-yellow-700/10",
    "CLOSED": "border-red-300 dark:border-red-700 bg-red-200/20 dark:bg-red-700/10",
};

type Props = {
    status: FulfillmentStatus,
    selected: boolean,
    disabled: boolean,
    title: string,
    description: string,
    onClick: () => void,
};

const ToggleButton = ({status, selected, disabled, title, description, onClick}: Props) => {
    return (
        <button
            className={twJoin(
                "transition group w-full flex flex-col gap-2 items-start justify-start text-left text-sm border rounded-lg p-3 ring-blue-500 dark:ring-blue-800 hover:ring-1",
                selected
                    ? buttonClassNames[status]
                    : "border-gray-200 dark:border-slate-700",
                disabled ? "opacity-30" : "",
            )}
            aria-selected={selected}
            disabled={disabled}
            onClick={e => {
                e.preventDefault();
                onClick();
            }}
        >
            <div className={"w-full flex flex-row items-center justify-start gap-2"}>
                <Icon
                    icon={CheckCircleIcon}
                    className={"grow-0 shrink-0 size-[16px] fill-gray-300 dark:fill-slate-500 group-aria-selected:fill-green-600 group-aria-selected:dark:fill-green-400"}
                />
                <h4 className={"font-medium"}>
                    {title}
                </h4>
            </div>

            <p className={"text-[95%] text-gray-500 dark:text-slate-400"}>
                {description}
            </p>
        </button>
    );
};

export default ToggleButton;